
const Detail = function(config, searchParametersService) {

  const template = `
    <div class="col-md-{{ col }}">
      <div class="my-well well well-sm">
        <span class="attribute"> {{ displayName + ':' }} </span>
        <span ng-if="!oseLink && !quickSearchLink && !caseLink && !wellLink">
          {{ attribute }}
        </span>
        <span ng-if="oseLink"><a ng-href="{{ oseLink }}" target="_blank">{{ attribute }}</a></span>
        <span ng-if="caseLink">
          <a ng-href="{{ occCaseEndpoint + caseLink }}">{{ attribute }}</a>
        </span>
        <span ng-if="wellLink && attribute == 'OK'">
          <a ng-href="{{ occWellsEndpoint + (wellLink | limitTo: occApiSubstring) }}" target="_blank">
            {{ attribute }}
          </a>
        </span>
        <span ng-if="wellLink && attribute == 'TX'">
            {{ attribute }}
        </span>
        <span ng-if="quickSearchLink">
          <a
            ng-click="searchParametersService.fromQuick()"
            ng-href="#/search?{{ quickSearchLink }}={{attribute}}&autoSearch=true"
          >
            {{ attribute }}
          </a>
        </span>
      </div>
    </div>
  `

  function link($scope) {
    $scope.searchParametersService = searchParametersService
    $scope.occCaseEndpoint = config.occCaseEndpoint
    $scope.occWellsEndpoint = config.occWellsEndpoint
    $scope.occApiSubstring = -8
  }

  return {
    template: template,
    link: link,
    scope: {
      attribute: '=',
      displayName: '@',
      col: '@',
      oseLink: '=',
      caseLink: '=',
      wellLink: '=',
      quickSearchLink: '@'
    }
  }
}

Detail.$inject = [ 'config', 'SearchParametersService' ]

export default Detail
